import styled from '@emotion/styled';
import { ReactNode } from 'react';

type Props = {
  children: ReactNode;
  hidden: boolean;
};

export const HiddenComponent = ({ children, hidden }: Props) => {
  return <S.Wrapper hidden={hidden}>{children}</S.Wrapper>;
};

const S = {
  Wrapper: styled.div`
    display: ${(props) => (props.hidden ? 'none' : 'block')};
  `,
};
